<table style="width: 100%">
  <tr *ngFor="let countryCalculatorModel of countryCalculators">
    <div class="flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
      <div class="fflag ff-sm fflag-{{countryCalculatorModel.code.toUpperCase()}} m-r-10"></div>
      <div matTooltip="{{countryCalculatorModel.name}}" matTooltipPosition="right">{{countryCalculatorModel.name}}</div>
    </div>
  </tr>
</table>

